import type { CuratedSurfaceSlotOut } from '@/api/generated/schemas';

/** Form.List row of the hero lineup editor. Order is the only order —
 * the surface derives positions server-side. */
export interface HeroLineupRow {
  publication_id?: number | null;
}

/** Server slots → editor rows, sorted by position (server order is not
 * guaranteed). */
export const heroSlotsToRows = (
  slots: CuratedSurfaceSlotOut[] | undefined | null
): HeroLineupRow[] =>
  [...(slots ?? [])]
    .sort((a, b) => a.position - b.position)
    .map((slot) => ({ publication_id: slot.publication_id }));

/** Editor rows → PUT payload; rows without a pick are dropped. */
export const heroRowsToPublicationIds = (
  rows: (HeroLineupRow | undefined | null)[] | undefined | null
): number[] =>
  (rows ?? [])
    .map((row) => row?.publication_id)
    .filter((id): id is number => id != null);
